import { AuthEffects } from './../../auth/state/auth.effects';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/reducers';
import { AuthService } from '../../auth/service/auth.service';
import { isLoggedIn } from '../../auth/state/auth.selectors';

@Component({
    selector: 'app-ping',
    templateUrl: './app-ping.component.html',
    styleUrls: ['./app-ping.component.scss']
})
export class AppPingComponent implements OnInit {
    pingable: boolean = false;
    pingableLockout: boolean = false;

    readonly TIMEOUT_DURATION_MS: number = 60000;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private store: Store<AppState>,
        private authService: AuthService,
        private authEffects: AuthEffects
    ) {
        document.addEventListener('click', this.onDocumentClick.bind(this));
    }

    ngOnInit(): void {
        this.authEffects.isLoggedIn$?.subscribe((x: boolean) => {
            if (x) {
                this.pingable = true;
            } else {
                this.pingable = false;
            }
        });
    }

    onDocumentClick() {
        if (this.pingable && !this.pingableLockout) {
            this.ping();
        }
    }

    ping() {
        this.authService.ping().subscribe((res) => {
            this.refreshPingTimeout();
        });
    }

    refreshPingTimeout() {
        this.pingableLockout = true;
        setTimeout(() => {
            this.pingableLockout = false;
        }, this.TIMEOUT_DURATION_MS);
    }
}
